import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { jobInputGroupsClearStore } from 'reducers/jobInputGroupsAdmin/reducer'
import JobInputGroupList from './JobInputGroupList'
import JobInputGroupItem from './JobInputGroupItem'

function JobInputGroups(props) {
  const {
    match: {
      params: { id },
    },
    jobInputGroupsClearStore,
  } = props

  useEffect(
    () => () => {
      jobInputGroupsClearStore()
    },
    [],
  )

  return (
    <div className="content">
      {id ? (
        <JobInputGroupItem {...props} />
      ) : (
        <JobInputGroupList {...props} isStateCriteria />
      )}
    </div>
  )
}

JobInputGroups.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  jobInputGroupsClearStore: PropTypes.func.isRequired,
}

export default connect(null, {
  jobInputGroupsClearStore,
})(JobInputGroups)
